export const skinCustom = {
  lightComponents: {
    body: '#ECEFF1',
    gradient: {
      gradientDefault1: '#000000',
      gradientDefault2: '#9a6d4b',
    },
  },
  darkComponents: {
    body: '#263238',
    gradient: {
      gradientDefault1: '#172260',
      gradientDefault2: '#000000',
    },
  },
}

export const image = {
  principal: 'https://hayasakicertificadora.com.br/image-bank/logo.png',
  favicon: 'https://hayasakicertificadora.com.br/image-bank/icone.png',
}

export const seo = {
  titulo: 'Hayasaki Certificadora',
  email: 'hayasaki@hayasakicertificadora.com.br',
  palavrasChave:
    'Certificado Digital, Cnpj a1, Cpf a1, emitir certificado, certificado São José do Rio Preto',
  descricao:
    'Empresa líder em Certificação Digital, oferecendo soluções seguras e confiáveis para empresas e indivíduos, com ampla experiência no mercado.',
  descricaoPWA:
    'Certificados digitais são identidades eletrônicas seguras usadas para autenticar usuários, proteger informações e realizar transações online com segurança.',
}

export const header = {
  empresa: false,
  solucoes: false,
  contato: true,
  trabalheConosco: false,
  duvidasSuporte: true,
  parcerias: false,
  darkMode: false,
  contaLogin: true,
}

export const contentHome = {
  sispass: false,
  produtorRural: false,
  modalidadesCertificado: false,
  ratingGoogle: false,
}

export const footer = {
  is0800: false,
  telefone: '17 99728-3504',
  whatsapp: '(17) 99728-3504',
  botaoRenocao: '17997283504',
  comercial: '17997283504',
  marketing: '17 99728-3504',
  botaoWhatsapp: '17997283504',
  number0800: '0800 600 2710',
  cidadeuf: 'São José do Rio Preto/SP',
  cidade: 'São José do Rio Preto',
  bairro: 'Vila Santo Antonio',
  titulo: 'Certificado Digital em São José do Rio Preto',
  rua: 'Rua Independencia',
  numero: '3504',
  complemento: 'sala 1',
  cep: '15014-400',
  cnpj: '',
  messageContador: 'Olá, tenho interesse em ser Parceiro Indicador.',
  messageRevenda: 'Olá, tenho interesse em revender Certificados Digitais',
  messageAgendamento: 'Olá, gostaria de agendar a emissão do meu Certificado',
  messageRenovacao: 'Olá, gostaria de renovar meu Certificado Digital',
  messageRenovacaoSispass:
    'Olá, gostaria de renovar meu Certificado Digital Sispass',
  messageConhecaNossasSolucoes:
    'Olá, gostaria de conhecer as soluções da Hayasaki Certificadora',
}

export const redes = {
  facebook:
    'https://www.facebook.com/hayasakicertificadoradigital/?locale=pt_BR',
  instagram: 'https://www.instagram.com/hayasakicertificadoradigital/',
  linkedin: '',
}

export const digisac = {
  id: 'df7a6a14-269a-46ba-a874-33c45e74badf',
  status: false,
}

export const ratings = [
  {
    id: 1,
    descricao: 'Suporte e Atendimento excelentes!',
    author: 'Leonardo Lopes',
    ratingvalue: 5,
  },
  {
    id: 2,
    descricao:
      'Atendimento excelente. Super ágil, prático e simplificado! Ótima organização da equipe.',
    author: 'Tháliton Morais',
    ratingvalue: 5,
  },
  {
    id: 3,
    descricao: 'Atendimento do Suporte Técnico nota 10!.',
    author: 'Felipe Mourão',
    ratingvalue: 5,
  },
]
